export const CONTRACT_ADDRESS = "0xAAfA7Ef15233B80E0B99E125228f30220450784e";
export const COINSTORE_URL = "https://www.coinstore.com/spot/MEDCUSDT";
export const PANCAKESWAP_URL = `https://pancakeswap.finance/swap?outputCurrency=${CONTRACT_ADDRESS}`;
export const LIVE_CHART_URL =
  "https://www.dextools.io/app/en/bnb/pair-explorer/0x34cefc7e43eead3390fc03c98f175132d637e5a9?t=1758352472251";
